// @generated by frontend/scripts/generate-validation-codes.mjs
// Source: backend/community/validation.py → backend/community/validation_codes.json
// Do not edit by hand — run `make generate-codes`.
//
// This file declares the wire-format code strings and a ValidationCode union.
// UI copy for these codes lives in validationCodes.ts (messageForCode).

export const Code = {
  Event: {
    NotFound: 'event.not_found',
    StartDatetimeRequiredUnlessTbd: 'event.start_datetime_required_unless_tbd',
    MaxAttendeesMustBeAtLeastOne: 'event.max_attendees_must_be_at_least_one',
    StartDatetimeMustBeFuture: 'event.start_datetime_must_be_future',
    EndBeforeStart: 'event.end_before_start',
    DatetimeOffsetRequired: 'event.datetime_offset_required',
    OfficialMustBePublic: 'event.official_must_be_public',
    OfficialNoPlusOnes: 'event.official_no_plus_ones',
    InvalidCreateStatus: 'event.invalid_create_status',
    DateLockedByPoll: 'event.date_locked_by_poll',
    AuthRequired: 'event.auth_required',
    CancelledCannotBeEdited: 'event.cancelled_cannot_be_edited',
    PastCannotBeCancelled: 'event.past_cannot_be_cancelled',
    NoAttendeesCannotBeCancelled: 'event.no_attendees_cannot_be_cancelled',
    HasRsvps: 'event.has_rsvps',
    PastCannotBeUnpublished: 'event.past_cannot_be_unpublished',
    InvalidStatusTransition: 'event.invalid_status_transition',
    CancelBeforeDelete: 'event.cancel_before_delete',
    FlagAlreadyFlagged: 'event.flag_already_flagged',
    FlagInvalidAction: 'event.flag_invalid_action',
    RsvpsNotEnabled: 'event.rsvps_not_enabled',
    RsvpsClosedCancelled: 'event.rsvps_closed_cancelled',
    RsvpsClosedPast: 'event.rsvps_closed_past',
    RsvpInvalidStatus: 'event.rsvp_invalid_status',
    NoPlusOneSpots: 'event.no_plus_one_spots',
    RsvpNotFound: 'event.rsvp_not_found',
    PaymentVerifyNotGuests: 'event.payment_verify_not_guests',
    WaitlistOrderStale: 'event.waitlist_order_stale',
    MemberContactMustSignIn: 'event.member_contact_must_sign_in',
    RsvpCouldNotBeCreated: 'event.rsvp_could_not_be_created',
    AttendanceOpensLater: 'event.attendance_opens_later',
    NoPlusOneToCheckIn: 'event.no_plus_one_to_check_in',
    PermDenied: 'event.perm_denied',
    BlastInvalidAudience: 'event.blast_invalid_audience',
    BlastNoRecipients: 'event.blast_no_recipients',
    WouldRemoveNonMembers: 'event.would_remove_non_members',
    RsvpQuestionNotFound: 'event.rsvp_question_not_found',
    RsvpQuestionDuplicate: 'event.rsvp_question_duplicate',
    RsvpQuestionConflict: 'event.rsvp_question_conflict',
    RsvpQuestionOptionsRequired: 'event.rsvp_question_options_required',
    RsvpAnswerRequired: 'event.rsvp_answer_required',
    RsvpAnswerInvalidOption: 'event.rsvp_answer_invalid_option',
    RsvpAnswerInvalidFormat: 'event.rsvp_answer_invalid_format',
    RsvpAnswerTooLong: 'event.rsvp_answer_too_long',
    PaymentConfirmationRequired: 'event.payment_confirmation_required',
    CheckInReportNotYetAvailable: 'event.check_in_report_not_yet_available',
    CheckInReportInvalidColumn: 'event.check_in_report_invalid_column',
    SlugInvalid: 'event.slug_invalid',
    SlugTaken: 'event.slug_taken',
  },
  Poll: {
    NotFound: 'poll.not_found',
    OptionsRequired: 'poll.options_required',
    OptionsMustBeFuture: 'poll.options_must_be_future',
    EventAlreadyHasPoll: 'poll.event_already_has_poll',
    OptionNotFound: 'poll.option_not_found',
    OptionAlreadyExists: 'poll.option_already_exists',
    CannotModifyFinalized: 'poll.cannot_modify_finalized',
    AlreadyFinalized: 'poll.already_finalized',
    WinningOptionNotFound: 'poll.winning_option_not_found',
    MinTwoOptions: 'poll.min_two_options',
    TooManyOptions: 'poll.too_many_options',
    InvalidAvailability: 'poll.invalid_availability',
  },
  Tag: {
    NotFound: 'tag.not_found',
    NameRequired: 'tag.name_required',
    NameAlreadyExists: 'tag.name_already_exists',
  },
  Comment: {
    NotFound: 'comment.not_found',
    ReplyDepthExceeded: 'comment.reply_depth_exceeded',
    InvalidEmoji: 'comment.invalid_emoji',
    RsvpRequired: 'comment.rsvp_required',
    PermDenied: 'comment.perm_denied',
    EventMismatch: 'comment.event_mismatch',
  },
  Url: {
    Invalid: 'url.invalid',
    TooLong: 'url.too_long',
    PathRequired: 'url.path_required',
    SchemeMustBeHttpOrHttps: 'url.scheme_must_be_http_or_https',
    WhatsappNotRecognized: 'url.whatsapp_not_recognized',
    PartifulNotRecognized: 'url.partiful_not_recognized',
  },
  Phone: {
    Invalid: 'phone.invalid',
    AlreadyExists: 'phone.already_exists',
  },
  Email: {
    Invalid: 'email.invalid',
    AlreadyExists: 'email.already_exists',
    Required: 'email.required',
  },
  Zelle: {
    Invalid: 'zelle.invalid',
  },
  DisplayName: {
    Required: 'display_name.required',
    TooLong: 'display_name.too_long',
    InvalidChars: 'display_name.invalid_chars',
    NeedsALetter: 'display_name.needs_a_letter',
  },
  Auth: {
    InvalidCredentials: 'auth.invalid_credentials',
    AccountArchived: 'auth.account_archived',
    AccountPaused: 'auth.account_paused',
    MagicLinkInvalidOrExpired: 'auth.magic_link_invalid_or_expired',
    MagicLinkAlreadyUsed: 'auth.magic_link_already_used',
    AlreadySignedInAsDifferentUser: 'auth.already_signed_in_as_different_user',
    RefreshTokenInvalid: 'auth.refresh_token_invalid',
    RefreshFailed: 'auth.refresh_failed',
    CurrentPasswordIncorrect: 'auth.current_password_incorrect',
    PasswordResetRequired: 'auth.password_reset_required',
    OnboardingRequired: 'auth.onboarding_required',
    GuidelinesConsentRequired: 'auth.guidelines_consent_required',
  },
  Password: {
    Invalid: 'password.invalid',
    SameAsOld: 'password.same_as_old',
  },
  Role: {
    NotFound: 'role.not_found',
    NameAlreadyExists: 'role.name_already_exists',
    ProtectedCannotEdit: 'role.protected_cannot_edit',
    ProtectedCannotRename: 'role.protected_cannot_rename',
    ProtectedCannotDelete: 'role.protected_cannot_delete',
    CannotRemoveOwnAdmin: 'role.cannot_remove_own_admin',
    CannotRemoveLastAdmin: 'role.cannot_remove_last_admin',
    CannotGrantAdmin: 'role.cannot_grant_admin',
    InvalidPermission: 'role.invalid_permission',
    MemberRoleRequired: 'role.member_role_required',
  },
  Member: {
    NotFound: 'member.not_found',
  },
  User: {
    NotFound: 'user.not_found',
    CannotDeleteSelf: 'user.cannot_delete_self',
    CannotDeleteLastAdmin: 'user.cannot_delete_last_admin',
    AlreadyArchived: 'user.already_archived',
    CannotHardDeleteLoggedIn: 'user.cannot_hard_delete_logged_in',
    CannotPauseSelf: 'user.cannot_pause_self',
    CannotPauseAdmin: 'user.cannot_pause_admin',
    RoleIdsNotFound: 'user.role_ids_not_found',
    InvalidBirthday: 'user.invalid_birthday',
    InvalidVeganniversary: 'user.invalid_veganniversary',
  },
  Survey: {
    NotFound: 'survey.not_found',
    Closed: 'survey.closed',
    SlugAlreadyExists: 'survey.slug_already_exists',
    ClosesBeforeOpens: 'survey.closes_before_opens',
    QuestionNotFound: 'survey.question_not_found',
    ResponseNotFound: 'survey.response_not_found',
    AnonymousLocked: 'survey.anonymous_locked',
    FeedbackTypeTaken: 'survey.feedback_type_taken',
    FeedbackLinkInvalid: 'survey.feedback_link_invalid',
    FeedbackAlreadySubmitted: 'survey.feedback_already_submitted',
    AnswerRequired: 'survey.answer_required',
    AnswerInvalidFormat: 'survey.answer_invalid_format',
    AnswerInvalidOption: 'survey.answer_invalid_option',
    AnswerMustBeNumber: 'survey.answer_must_be_number',
    AnswerMustBeBoolean: 'survey.answer_must_be_boolean',
    AnswerRatingOutOfRange: 'survey.answer_rating_out_of_range',
    AnswerInvalidDatetimeOption: 'survey.answer_invalid_datetime_option',
    AnswerInvalidAvailability: 'survey.answer_invalid_availability',
    ConditionQuestionNotFound: 'survey.condition_question_not_found',
    ConditionQuestionNotEarlier: 'survey.condition_question_not_earlier',
    ConditionTypeNotSupported: 'survey.condition_type_not_supported',
    ConditionOperatorNotSupported: 'survey.condition_operator_not_supported',
    ConditionValueInvalid: 'survey.condition_value_invalid',
    ConditionOrderConflict: 'survey.condition_order_conflict',
    ConditionSourceInUse: 'survey.condition_source_in_use',
  },
  JoinRequest: {
    NotFound: 'join_request.not_found',
    AlreadyDecided: 'join_request.already_decided',
    OnlyRejectedCanBeUnRejected: 'join_request.only_rejected_can_be_un_rejected',
    AlreadyMember: 'join_request.already_member',
    PhoneAlreadyInvited: 'join_request.phone_already_invited',
    PhoneAlreadyPending: 'join_request.phone_already_pending',
    PhoneAlreadyTentative: 'join_request.phone_already_tentative',
    AnswerRequired: 'join_request.answer_required',
    AnswerTooLong: 'join_request.answer_too_long',
    AnswerInvalidOption: 'join_request.answer_invalid_option',
    InvalidStatus: 'join_request.invalid_status',
    NotApproved: 'join_request.not_approved',
    AlreadyLoggedIn: 'join_request.already_logged_in',
    SmsConsentRequired: 'join_request.sms_consent_required',
    GuidelinesConsentRequired: 'join_request.guidelines_consent_required',
    InvalidRejectionReason: 'join_request.invalid_rejection_reason',
    RejectionNoteRequired: 'join_request.rejection_note_required',
    RejectionNoteTooLong: 'join_request.rejection_note_too_long',
  },
  Photo: {
    TypeNotAllowed: 'photo.type_not_allowed',
    TooLarge: 'photo.too_large',
    Unsafe: 'photo.unsafe',
  },
  AttendanceImport: {
    CsvEmpty: 'attendance_import.csv_empty',
    CsvMalformed: 'attendance_import.csv_malformed',
    EventOrTitleRequired: 'attendance_import.event_or_title_required',
    InvalidEventType: 'attendance_import.invalid_event_type',
    AmbiguousUserPick: 'attendance_import.ambiguous_user_pick',
  },
  CashAppImport: {
    CsvEmpty: 'cashapp_import.csv_empty',
    CsvMissingColumns: 'cashapp_import.csv_missing_columns',
    CsvTooManyRows: 'cashapp_import.csv_too_many_rows',
  },
  AttendanceMark: {
    EventOrTitleRequired: 'attendance_mark.event_or_title_required',
    InvalidEventType: 'attendance_mark.invalid_event_type',
    NoMembersSelected: 'attendance_mark.no_members_selected',
  },
  Perm: {
    Denied: 'perm.denied',
  },
  Rate: {
    Limited: 'rate.limited',
  },
  Page: {
    MembersOnly: 'page.members_only',
    VisibilityInvalid: 'page.visibility_invalid',
  },
  DevTools: {
    NotFound: 'dev_tools.not_found',
  },
  Docs: {
    FolderNotFound: 'docs.folder_not_found',
    ParentFolderNotFound: 'docs.parent_folder_not_found',
    DocumentNotFound: 'docs.document_not_found',
  },
  JoinForm: {
    QuestionNotFound: 'join_form.question_not_found',
  },
  Feedback: {
    NotConfigured: 'feedback.not_configured',
    CreationFailed: 'feedback.creation_failed',
  },
  Notification: {
    NotFound: 'notification.not_found',
  },
  CoHostInvite: {
    NotFound: 'cohost_invite.not_found',
    NotPending: 'cohost_invite.not_pending',
    NotInvitee: 'cohost_invite.not_invitee',
    NotHost: 'cohost_invite.not_host',
    NotRemovable: 'cohost_invite.not_removable',
    WouldLeaveHostless: 'cohost_invite.would_leave_hostless',
    EventIsPast: 'cohost_invite.event_is_past',
    NotMember: 'cohost_invite.not_member',
  },
  WelcomeTemplate: {
    BodyRequired: 'welcome_template.body_required',
    BodyTooLong: 'welcome_template.body_too_long',
  },
  TentativeApprovalMessage: {
    BodyRequired: 'tentative_approval_message.body_required',
    BodyTooLong: 'tentative_approval_message.body_too_long',
  },
  MemberPromotionMessage: {
    BodyRequired: 'member_promotion_message.body_required',
    BodyTooLong: 'member_promotion_message.body_too_long',
  },
  MemberPromotionEmail: {
    BodyRequired: 'member_promotion_email.body_required',
    BodyTooLong: 'member_promotion_email.body_too_long',
  },
  RejectionEmail: {
    BodyRequired: 'rejection_email.body_required',
    BodyTooLong: 'rejection_email.body_too_long',
    ReasonTextRequired: 'rejection_email.reason_text_required',
    ReasonTextTooLong: 'rejection_email.reason_text_too_long',
  },
  Connect: {
    RequestNotFound: 'connect.request_not_found',
    RequestExpired: 'connect.request_expired',
    RequestAlreadyUsed: 'connect.request_already_used',
    AppNotFound: 'connect.app_not_found',
  },
} as const;

export type ValidationCode =
  | 'event.not_found'
  | 'event.start_datetime_required_unless_tbd'
  | 'event.max_attendees_must_be_at_least_one'
  | 'event.start_datetime_must_be_future'
  | 'event.end_before_start'
  | 'event.datetime_offset_required'
  | 'event.official_must_be_public'
  | 'event.official_no_plus_ones'
  | 'event.invalid_create_status'
  | 'event.date_locked_by_poll'
  | 'event.auth_required'
  | 'event.cancelled_cannot_be_edited'
  | 'event.past_cannot_be_cancelled'
  | 'event.no_attendees_cannot_be_cancelled'
  | 'event.has_rsvps'
  | 'event.past_cannot_be_unpublished'
  | 'event.invalid_status_transition'
  | 'event.cancel_before_delete'
  | 'event.flag_already_flagged'
  | 'event.flag_invalid_action'
  | 'event.rsvps_not_enabled'
  | 'event.rsvps_closed_cancelled'
  | 'event.rsvps_closed_past'
  | 'event.rsvp_invalid_status'
  | 'event.no_plus_one_spots'
  | 'event.rsvp_not_found'
  | 'event.payment_verify_not_guests'
  | 'event.waitlist_order_stale'
  | 'event.member_contact_must_sign_in'
  | 'event.rsvp_could_not_be_created'
  | 'event.attendance_opens_later'
  | 'event.no_plus_one_to_check_in'
  | 'event.perm_denied'
  | 'event.blast_invalid_audience'
  | 'event.blast_no_recipients'
  | 'event.would_remove_non_members'
  | 'event.rsvp_question_not_found'
  | 'event.rsvp_question_duplicate'
  | 'event.rsvp_question_conflict'
  | 'event.rsvp_question_options_required'
  | 'event.rsvp_answer_required'
  | 'event.rsvp_answer_invalid_option'
  | 'event.rsvp_answer_invalid_format'
  | 'event.rsvp_answer_too_long'
  | 'event.payment_confirmation_required'
  | 'event.check_in_report_not_yet_available'
  | 'event.check_in_report_invalid_column'
  | 'event.slug_invalid'
  | 'event.slug_taken'
  | 'poll.not_found'
  | 'poll.options_required'
  | 'poll.options_must_be_future'
  | 'poll.event_already_has_poll'
  | 'poll.option_not_found'
  | 'poll.option_already_exists'
  | 'poll.cannot_modify_finalized'
  | 'poll.already_finalized'
  | 'poll.winning_option_not_found'
  | 'poll.min_two_options'
  | 'poll.too_many_options'
  | 'poll.invalid_availability'
  | 'tag.not_found'
  | 'tag.name_required'
  | 'tag.name_already_exists'
  | 'comment.not_found'
  | 'comment.reply_depth_exceeded'
  | 'comment.invalid_emoji'
  | 'comment.rsvp_required'
  | 'comment.perm_denied'
  | 'comment.event_mismatch'
  | 'url.invalid'
  | 'url.too_long'
  | 'url.path_required'
  | 'url.scheme_must_be_http_or_https'
  | 'url.whatsapp_not_recognized'
  | 'url.partiful_not_recognized'
  | 'phone.invalid'
  | 'phone.already_exists'
  | 'email.invalid'
  | 'email.already_exists'
  | 'email.required'
  | 'zelle.invalid'
  | 'display_name.required'
  | 'display_name.too_long'
  | 'display_name.invalid_chars'
  | 'display_name.needs_a_letter'
  | 'auth.invalid_credentials'
  | 'auth.account_archived'
  | 'auth.account_paused'
  | 'auth.magic_link_invalid_or_expired'
  | 'auth.magic_link_already_used'
  | 'auth.already_signed_in_as_different_user'
  | 'auth.refresh_token_invalid'
  | 'auth.refresh_failed'
  | 'auth.current_password_incorrect'
  | 'auth.password_reset_required'
  | 'auth.onboarding_required'
  | 'auth.guidelines_consent_required'
  | 'password.invalid'
  | 'password.same_as_old'
  | 'role.not_found'
  | 'role.name_already_exists'
  | 'role.protected_cannot_edit'
  | 'role.protected_cannot_rename'
  | 'role.protected_cannot_delete'
  | 'role.cannot_remove_own_admin'
  | 'role.cannot_remove_last_admin'
  | 'role.cannot_grant_admin'
  | 'role.invalid_permission'
  | 'role.member_role_required'
  | 'member.not_found'
  | 'user.not_found'
  | 'user.cannot_delete_self'
  | 'user.cannot_delete_last_admin'
  | 'user.already_archived'
  | 'user.cannot_hard_delete_logged_in'
  | 'user.cannot_pause_self'
  | 'user.cannot_pause_admin'
  | 'user.role_ids_not_found'
  | 'user.invalid_birthday'
  | 'user.invalid_veganniversary'
  | 'survey.not_found'
  | 'survey.closed'
  | 'survey.slug_already_exists'
  | 'survey.closes_before_opens'
  | 'survey.question_not_found'
  | 'survey.response_not_found'
  | 'survey.anonymous_locked'
  | 'survey.feedback_type_taken'
  | 'survey.feedback_link_invalid'
  | 'survey.feedback_already_submitted'
  | 'survey.answer_required'
  | 'survey.answer_invalid_format'
  | 'survey.answer_invalid_option'
  | 'survey.answer_must_be_number'
  | 'survey.answer_must_be_boolean'
  | 'survey.answer_rating_out_of_range'
  | 'survey.answer_invalid_datetime_option'
  | 'survey.answer_invalid_availability'
  | 'survey.condition_question_not_found'
  | 'survey.condition_question_not_earlier'
  | 'survey.condition_type_not_supported'
  | 'survey.condition_operator_not_supported'
  | 'survey.condition_value_invalid'
  | 'survey.condition_order_conflict'
  | 'survey.condition_source_in_use'
  | 'join_request.not_found'
  | 'join_request.already_decided'
  | 'join_request.only_rejected_can_be_un_rejected'
  | 'join_request.already_member'
  | 'join_request.phone_already_invited'
  | 'join_request.phone_already_pending'
  | 'join_request.phone_already_tentative'
  | 'join_request.answer_required'
  | 'join_request.answer_too_long'
  | 'join_request.answer_invalid_option'
  | 'join_request.invalid_status'
  | 'join_request.not_approved'
  | 'join_request.already_logged_in'
  | 'join_request.sms_consent_required'
  | 'join_request.guidelines_consent_required'
  | 'join_request.invalid_rejection_reason'
  | 'join_request.rejection_note_required'
  | 'join_request.rejection_note_too_long'
  | 'photo.type_not_allowed'
  | 'photo.too_large'
  | 'photo.unsafe'
  | 'attendance_import.csv_empty'
  | 'attendance_import.csv_malformed'
  | 'attendance_import.event_or_title_required'
  | 'attendance_import.invalid_event_type'
  | 'attendance_import.ambiguous_user_pick'
  | 'cashapp_import.csv_empty'
  | 'cashapp_import.csv_missing_columns'
  | 'cashapp_import.csv_too_many_rows'
  | 'attendance_mark.event_or_title_required'
  | 'attendance_mark.invalid_event_type'
  | 'attendance_mark.no_members_selected'
  | 'perm.denied'
  | 'rate.limited'
  | 'page.members_only'
  | 'page.visibility_invalid'
  | 'dev_tools.not_found'
  | 'docs.folder_not_found'
  | 'docs.parent_folder_not_found'
  | 'docs.document_not_found'
  | 'join_form.question_not_found'
  | 'feedback.not_configured'
  | 'feedback.creation_failed'
  | 'notification.not_found'
  | 'cohost_invite.not_found'
  | 'cohost_invite.not_pending'
  | 'cohost_invite.not_invitee'
  | 'cohost_invite.not_host'
  | 'cohost_invite.not_removable'
  | 'cohost_invite.would_leave_hostless'
  | 'cohost_invite.event_is_past'
  | 'cohost_invite.not_member'
  | 'welcome_template.body_required'
  | 'welcome_template.body_too_long'
  | 'tentative_approval_message.body_required'
  | 'tentative_approval_message.body_too_long'
  | 'member_promotion_message.body_required'
  | 'member_promotion_message.body_too_long'
  | 'member_promotion_email.body_required'
  | 'member_promotion_email.body_too_long'
  | 'rejection_email.body_required'
  | 'rejection_email.body_too_long'
  | 'rejection_email.reason_text_required'
  | 'rejection_email.reason_text_too_long'
  | 'connect.request_not_found'
  | 'connect.request_expired'
  | 'connect.request_already_used'
  | 'connect.app_not_found';

export const CODE_PARAMS: Record<ValidationCode, readonly string[]> = {
  'event.not_found': [],
  'event.start_datetime_required_unless_tbd': [],
  'event.max_attendees_must_be_at_least_one': [],
  'event.start_datetime_must_be_future': [],
  'event.end_before_start': [],
  'event.datetime_offset_required': [],
  'event.official_must_be_public': [],
  'event.official_no_plus_ones': [],
  'event.invalid_create_status': [],
  'event.date_locked_by_poll': [],
  'event.auth_required': [],
  'event.cancelled_cannot_be_edited': [],
  'event.past_cannot_be_cancelled': [],
  'event.no_attendees_cannot_be_cancelled': [],
  'event.has_rsvps': [],
  'event.past_cannot_be_unpublished': [],
  'event.invalid_status_transition': [],
  'event.cancel_before_delete': [],
  'event.flag_already_flagged': [],
  'event.flag_invalid_action': [],
  'event.rsvps_not_enabled': [],
  'event.rsvps_closed_cancelled': [],
  'event.rsvps_closed_past': [],
  'event.rsvp_invalid_status': [],
  'event.no_plus_one_spots': [],
  'event.rsvp_not_found': [],
  'event.payment_verify_not_guests': ['user_ids'],
  'event.waitlist_order_stale': [],
  'event.member_contact_must_sign_in': [],
  'event.rsvp_could_not_be_created': [],
  'event.attendance_opens_later': [],
  'event.no_plus_one_to_check_in': [],
  'event.perm_denied': ['action'],
  'event.blast_invalid_audience': [],
  'event.blast_no_recipients': [],
  'event.would_remove_non_members': ['count'],
  'event.rsvp_question_not_found': [],
  'event.rsvp_question_duplicate': [],
  'event.rsvp_question_conflict': [],
  'event.rsvp_question_options_required': [],
  'event.rsvp_answer_required': ['label'],
  'event.rsvp_answer_invalid_option': ['label'],
  'event.rsvp_answer_invalid_format': ['label'],
  'event.rsvp_answer_too_long': ['label', 'max'],
  'event.payment_confirmation_required': [],
  'event.check_in_report_not_yet_available': [],
  'event.check_in_report_invalid_column': ['column'],
  'event.slug_invalid': [],
  'event.slug_taken': [],
  'poll.not_found': [],
  'poll.options_required': [],
  'poll.options_must_be_future': [],
  'poll.event_already_has_poll': [],
  'poll.option_not_found': [],
  'poll.option_already_exists': [],
  'poll.cannot_modify_finalized': [],
  'poll.already_finalized': [],
  'poll.winning_option_not_found': [],
  'poll.min_two_options': [],
  'poll.too_many_options': ['max'],
  'poll.invalid_availability': [],
  'tag.not_found': [],
  'tag.name_required': [],
  'tag.name_already_exists': [],
  'comment.not_found': [],
  'comment.reply_depth_exceeded': [],
  'comment.invalid_emoji': [],
  'comment.rsvp_required': [],
  'comment.perm_denied': [],
  'comment.event_mismatch': [],
  'url.invalid': [],
  'url.too_long': ['max_length'],
  'url.path_required': [],
  'url.scheme_must_be_http_or_https': [],
  'url.whatsapp_not_recognized': [],
  'url.partiful_not_recognized': [],
  'phone.invalid': [],
  'phone.already_exists': [],
  'email.invalid': [],
  'email.already_exists': [],
  'email.required': [],
  'zelle.invalid': [],
  'display_name.required': [],
  'display_name.too_long': ['max_length'],
  'display_name.invalid_chars': [],
  'display_name.needs_a_letter': [],
  'auth.invalid_credentials': [],
  'auth.account_archived': [],
  'auth.account_paused': [],
  'auth.magic_link_invalid_or_expired': [],
  'auth.magic_link_already_used': [],
  'auth.already_signed_in_as_different_user': [],
  'auth.refresh_token_invalid': [],
  'auth.refresh_failed': [],
  'auth.current_password_incorrect': [],
  'auth.password_reset_required': [],
  'auth.onboarding_required': [],
  'auth.guidelines_consent_required': [],
  'password.invalid': ['reasons'],
  'password.same_as_old': [],
  'role.not_found': [],
  'role.name_already_exists': [],
  'role.protected_cannot_edit': [],
  'role.protected_cannot_rename': [],
  'role.protected_cannot_delete': [],
  'role.cannot_remove_own_admin': [],
  'role.cannot_remove_last_admin': [],
  'role.cannot_grant_admin': [],
  'role.invalid_permission': ['permission'],
  'role.member_role_required': [],
  'member.not_found': [],
  'user.not_found': [],
  'user.cannot_delete_self': [],
  'user.cannot_delete_last_admin': [],
  'user.already_archived': [],
  'user.cannot_hard_delete_logged_in': [],
  'user.cannot_pause_self': [],
  'user.cannot_pause_admin': [],
  'user.role_ids_not_found': [],
  'user.invalid_birthday': [],
  'user.invalid_veganniversary': [],
  'survey.not_found': [],
  'survey.closed': [],
  'survey.slug_already_exists': [],
  'survey.closes_before_opens': [],
  'survey.question_not_found': [],
  'survey.response_not_found': [],
  'survey.anonymous_locked': [],
  'survey.feedback_type_taken': [],
  'survey.feedback_link_invalid': [],
  'survey.feedback_already_submitted': [],
  'survey.answer_required': ['label'],
  'survey.answer_invalid_format': ['label'],
  'survey.answer_invalid_option': ['label'],
  'survey.answer_must_be_number': ['label'],
  'survey.answer_must_be_boolean': ['label'],
  'survey.answer_rating_out_of_range': ['label'],
  'survey.answer_invalid_datetime_option': ['label'],
  'survey.answer_invalid_availability': ['label', 'value'],
  'survey.condition_question_not_found': [],
  'survey.condition_question_not_earlier': [],
  'survey.condition_type_not_supported': ['label'],
  'survey.condition_operator_not_supported': ['operator'],
  'survey.condition_value_invalid': ['label'],
  'survey.condition_order_conflict': ['label'],
  'survey.condition_source_in_use': ['label'],
  'join_request.not_found': [],
  'join_request.already_decided': [],
  'join_request.only_rejected_can_be_un_rejected': [],
  'join_request.already_member': [],
  'join_request.phone_already_invited': [],
  'join_request.phone_already_pending': [],
  'join_request.phone_already_tentative': [],
  'join_request.answer_required': ['label'],
  'join_request.answer_too_long': ['label', 'max'],
  'join_request.answer_invalid_option': ['label'],
  'join_request.invalid_status': ['allowed'],
  'join_request.not_approved': [],
  'join_request.already_logged_in': [],
  'join_request.sms_consent_required': [],
  'join_request.guidelines_consent_required': [],
  'join_request.invalid_rejection_reason': [],
  'join_request.rejection_note_required': [],
  'join_request.rejection_note_too_long': ['max_length'],
  'photo.type_not_allowed': ['allowed'],
  'photo.too_large': ['max_mb'],
  'photo.unsafe': [],
  'attendance_import.csv_empty': [],
  'attendance_import.csv_malformed': [],
  'attendance_import.event_or_title_required': [],
  'attendance_import.invalid_event_type': [],
  'attendance_import.ambiguous_user_pick': ['row_index'],
  'cashapp_import.csv_empty': [],
  'cashapp_import.csv_missing_columns': ['columns'],
  'cashapp_import.csv_too_many_rows': ['max_rows'],
  'attendance_mark.event_or_title_required': [],
  'attendance_mark.invalid_event_type': [],
  'attendance_mark.no_members_selected': [],
  'perm.denied': ['action'],
  'rate.limited': [],
  'page.members_only': [],
  'page.visibility_invalid': ['allowed'],
  'dev_tools.not_found': [],
  'docs.folder_not_found': [],
  'docs.parent_folder_not_found': [],
  'docs.document_not_found': [],
  'join_form.question_not_found': [],
  'feedback.not_configured': [],
  'feedback.creation_failed': [],
  'notification.not_found': [],
  'cohost_invite.not_found': [],
  'cohost_invite.not_pending': [],
  'cohost_invite.not_invitee': [],
  'cohost_invite.not_host': [],
  'cohost_invite.not_removable': [],
  'cohost_invite.would_leave_hostless': [],
  'cohost_invite.event_is_past': [],
  'cohost_invite.not_member': [],
  'welcome_template.body_required': [],
  'welcome_template.body_too_long': ['max_length'],
  'tentative_approval_message.body_required': [],
  'tentative_approval_message.body_too_long': ['max_length'],
  'member_promotion_message.body_required': [],
  'member_promotion_message.body_too_long': ['max_length'],
  'member_promotion_email.body_required': [],
  'member_promotion_email.body_too_long': ['max_length'],
  'rejection_email.body_required': [],
  'rejection_email.body_too_long': ['max_length'],
  'rejection_email.reason_text_required': [],
  'rejection_email.reason_text_too_long': ['max_length'],
  'connect.request_not_found': [],
  'connect.request_expired': [],
  'connect.request_already_used': [],
  'connect.app_not_found': [],
};
